// extracted by mini-css-extract-plugin
module.exports = {"container":"pensionsCard_container__2hhSl","disabled":"pensionsCard_disabled__2eMnr","icon-container":"pensionsCard_icon-container__1YHiW"};